module.exports = __webpack_public_path__ + "img/Yotta-Logo.c328d8.svg";